import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ScrollContext } from "../context/ScrollContext";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { scrollToSection, refs } = useContext(ScrollContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Forzar scroll para activar touch events en móviles
  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.scrollLeft = 0;
    }
  }, [menuOpen]);

  const handleNavClick = (section) => {
    setMenuOpen(false);
    const sectionRef = refs[section];
    if (location.pathname === "/") {
      if (sectionRef && sectionRef.current) {
        scrollToSection(sectionRef);
      } else {
        navigate("/", { state: { scrollTo: section } });
      }
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  const handleLogoClick = () => {
    setMenuOpen(false);
    const topRef = refs.topRef;
    if (location.pathname === "/") {
      if (topRef && topRef.current) scrollToSection(topRef);
    } else {
      navigate("/", { state: { scrollTo: "top" } });
    }
  };

  const links = [
    { label: "Quienes Somos", ref: "quienesRef" },
    { label: "Servicios", ref: "serviciosRef" },
    { label: "Clientes", ref: "clientesRef" },
    { label: "Testimonios", ref: "resenasRef" },
    { label: "Contacto", ref: "contactoRef" },
  ];

  return (
    <nav className="fixed w-full bg-primary text-white shadow-md z-50">
      <div className="flex justify-between items-center h-24 px-4 md:px-8">
        
        {/* Logo */}
        <div
          className="cursor-pointer flex items-center h-full ml-2 md:ml-4 flex-shrink-0"
          onClick={handleLogoClick}
        >
          <img
            src="/assets/logos/logo cs.png"
            alt="Core Solutions"
            className="h-20 md:h-24 object-contain"
          />
        </div>

        {/* Links escritorio ENCAPSULADOS EN UNA BURBUJA */}
        <div className="hidden md:flex flex-1 justify-end pr-12 min-w-max">
          <div className="bg-white/10 backdrop-blur-lg px-8 py-3 rounded-2xl shadow-lg border border-white/20">
            <ul className="flex space-x-10 text-lg md:text-[1.25rem] font-medium whitespace-nowrap">
              {links.map((item) => (
                <li key={item.ref} className="flex-shrink-0">
                  <button
                    onClick={() => handleNavClick(item.ref)}
                    className="cursor-pointer hover:text-secondary transition w-full h-full"
                    style={{ background: "none", border: "none", padding: 0 }}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Botón menú móvil */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="p-2 focus:outline-none"
          >
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Menú desplegable móvil */}
      {menuOpen && (
        <div
          ref={menuRef}
          className="md:hidden bg-primary text-white w-full shadow-md"
        >
          <ul className="flex flex-col px-4 py-4 space-y-4">
            {links.map((item) => (
              <li key={item.ref}>
                <button
                  onClick={() => handleNavClick(item.ref)}
                  className="w-full text-left text-lg hover:text-secondary transition pointer-events-auto"
                  style={{ background: "none", border: "none", padding: 0 }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
